import {makeAutoObservable} from "mobx";

export default class UserStore {
    constructor() {
        this._isLoggedIn = false;
        this._user = {};
        makeAutoObservable(this)
    }

    logout() {
        this._user = {};
        this._isLoggedIn = false;
        localStorage.removeItem('token')
    }

    setAuth(bool) {
        this._isLoggedIn = bool;
    }

    setUser(user) {
        this._user = user;
    }

    get isAuth() {
        return this._isLoggedIn
    }

    get user() {
        return this._user
    }

    get userRole() {
        return this._user.role
    }

    get userName() {
        return this._user.username
    }

}